import { resolveCommunicationChartInspectorNodeRole } from '@web/components/CommunicationNetworkGraph/core/communicationChart/nodeKind';
import { isCommunicationChartMeetChannel } from '@web/components/CommunicationNetworkGraph/core/communicationChart/types';
var chartBaseKey = 'app.dashboard.communicationChart';
var inspectorBaseKey = "".concat(chartBaseKey, ".inspector");
var SHARED_EXTENDED_FIELD_KEYS = new Set([
    'externalPartners',
    'externalShare',
    'crossTeamShare',
    'teamOnlyShare',
    'topPartnersTeams',
    'topPartnersExternal',
    'topPartnersGroups'
]);
export var communicationChartChannelKey = function (channel) { return "".concat(chartBaseKey, ".channels.").concat(channel); };
export var communicationChartAudienceKey = function (audienceKey) {
    return "".concat(chartBaseKey, ".audience.").concat(audienceKey);
};
export var communicationChartLinkInspectorComparisonKey = function (channel, rowKey) {
    if (isCommunicationChartMeetChannel(channel)) {
        if (rowKey === 'sent') {
            return "".concat(inspectorBaseKey, ".linkComparison.meetings");
        }
        if (rowKey === 'received') {
            return "".concat(inspectorBaseKey, ".linkComparison.duration");
        }
        if (rowKey === 'avgMeetingLength') {
            return "".concat(inspectorBaseKey, ".linkComparison.avgMeetingLength");
        }
    }
    return "".concat(inspectorBaseKey, ".linkComparison.").concat(rowKey);
};
export var communicationChartLinkInspectorExtendedFieldKey = function (fieldKey) { return "".concat(inspectorBaseKey, ".linkInspector.").concat(fieldKey); };
export var communicationChartInspectorFormatGroupSpaceKey = function () {
    return "".concat(inspectorBaseKey, ".formatLabels.groupSpace");
};
export var communicationChartInspectorSummaryKey = function (channel, suffix, options) {
    if (options === null || options === void 0 ? void 0 : options.externalHubChat) {
        if (suffix === 'sent') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentByCompany");
        }
        if (suffix === 'received') {
            return communicationChartLinkInspectorExtendedFieldKey('receivedFromExternal');
        }
    }
    if (options === null || options === void 0 ? void 0 : options.externalHubEmail) {
        if (suffix === 'sent') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentByCompany");
        }
        if (suffix === 'received') {
            return communicationChartLinkInspectorExtendedFieldKey('receivedFromExternal');
        }
    }
    if ((options === null || options === void 0 ? void 0 : options.externalHub) && suffix === 'where') {
        return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".whereExternal");
    }
    if ((options === null || options === void 0 ? void 0 : options.crossTeamHub) && suffix === 'where') {
        return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".whereCrossTeam");
    }
    if (suffix === 'sentByTeam') {
        return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentByTeam");
    }
    if (options === null || options === void 0 ? void 0 : options.teamCrossTeamSatellite) {
        if (suffix === 'sent') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentByTeam");
        }
        if (suffix === 'received') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".receivedFromCrossTeam");
        }
    }
    if ((options === null || options === void 0 ? void 0 : options.teamExternalEmail) || (options === null || options === void 0 ? void 0 : options.teamExternalChat)) {
        if (suffix === 'sent') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentByTeam");
        }
        if (suffix === 'received') {
            return communicationChartLinkInspectorExtendedFieldKey('receivedFromExternal');
        }
    }
    if ((options === null || options === void 0 ? void 0 : options.teamOnlyEmailSatellite) && suffix === 'sent') {
        return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentEmails");
    }
    if (options === null || options === void 0 ? void 0 : options.orgTeamEmail) {
        if (suffix === 'sent') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentEmails");
        }
        if (suffix === 'received') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".receivedEmails");
        }
    }
    if (options === null || options === void 0 ? void 0 : options.orgTeamChat) {
        if (suffix === 'sent') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".sentMessages");
        }
        if (suffix === 'received') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".receivedMessages");
        }
    }
    if (options === null || options === void 0 ? void 0 : options.orgTeamMeet) {
        if (suffix === 'received') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".duration");
        }
        if (suffix === 'totalEmployeeAttendanceDuration') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".totalEmployeeAttendanceDuration");
        }
    }
    if (options === null || options === void 0 ? void 0 : options.person) {
        if (suffix === 'sent' || suffix === 'received') {
            return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".").concat(suffix, "Person");
        }
    }
    if (suffix === 'format') {
        return "".concat(inspectorBaseKey, ".formatCompare");
    }
    if (suffix === 'split') {
        return isCommunicationChartMeetChannel(channel)
            ? "".concat(inspectorBaseKey, ".summary.meet.split")
            : "".concat(inspectorBaseKey, ".splitSentVsReceived");
    }
    return "".concat(inspectorBaseKey, ".summary.").concat(channel, ".").concat(suffix);
};
export var communicationChartInspectorUserRoleKey = function (role) {
    switch (role.toUpperCase()) {
        case 'ADMIN':
            return 'userRoles.admin';
        case 'MANAGER':
            return 'userRoles.manager';
        default:
            return 'userRoles.user';
    }
};
/** Employee details inspector: only managers get the manager label; everyone else is a team member. */
export var communicationChartInspectorPersonRoleLabelKey = function (role) {
    return (role === null || role === void 0 ? void 0 : role.toUpperCase()) === 'MANAGER'
        ? communicationChartInspectorUserRoleKey(role)
        : 'app.dashboard.communicationChart.inspector.teamMember';
};
export var communicationChartInspectorExtendedFieldKey = function (channel, fieldKey) {
    if (SHARED_EXTENDED_FIELD_KEYS.has(fieldKey)) {
        return "".concat(inspectorBaseKey, ".extended.shared.").concat(fieldKey);
    }
    return "".concat(inspectorBaseKey, ".extended.").concat(channel, ".").concat(fieldKey);
};
export var communicationChartInspectorTopPartnersTitleKey = function (channel) {
    return communicationChartInspectorExtendedFieldKey(channel, 'topPartnersTitle');
};
export var communicationChartInspectorTopPartnersByEmailsKey = function (channel) {
    return communicationChartInspectorExtendedFieldKey(channel, 'topPartnersByEmails');
};
export var communicationChartInspectorTopPartnerTeamsTitleKey = function (channel) {
    return communicationChartInspectorExtendedFieldKey(channel, 'topPartnerTeamsTitle');
};
export var communicationChartInspectorTopCrossTeamPartnersTitleKey = function (channel) {
    return communicationChartInspectorExtendedFieldKey(channel, 'topCrossTeamPartnersTitle');
};
export var communicationChartInspectorTopPostersTitleKey = function (channel) {
    if (channel === 'chat') {
        return communicationChartInspectorExtendedFieldKey(channel, 'topPostersTitle');
    }
    return communicationChartInspectorExtendedFieldKey(channel, 'topSendersTitle');
};
export var communicationChartInspectorTopPartnersSectionKey = function (channel, sectionKey) {
    return communicationChartInspectorExtendedFieldKey(channel, "topPartners".concat(sectionKey.charAt(0).toUpperCase()).concat(sectionKey.slice(1)));
};
export var communicationChartInspectorTopMeetingParticipantsTitleKey = function (channel) {
    return communicationChartInspectorExtendedFieldKey(channel, 'topMeetingParticipantsTitle');
};
export var communicationChartInspectorPartnerKindKey = function (kindKey) { return "".concat(inspectorBaseKey, ".partnerRole.").concat(kindKey); };
export var communicationChartInspectorNodeRoleKey = function (node) {
    return "".concat(inspectorBaseKey, ".nodeRole.").concat(resolveCommunicationChartInspectorNodeRole(node));
};
export var communicationChartInspectorFormatOneToOneKey = function () {
    return "".concat(inspectorBaseKey, ".formatLabels.oneToOne");
};
export var communicationChartInspectorFormatGroupKey = function () {
    return "".concat(inspectorBaseKey, ".formatLabels.group");
};
export var communicationChartInspectorUnassignedOrgUnitKey = function () {
    return "".concat(inspectorBaseKey, ".unassignedOrgUnit");
};
